// Cloned and modified from @tanstack/react-query-devtools/src/devtools.tsx
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { queryClient } from '../../api';
import type { DevPanelItemProps } from './DevPanel';

export function CustomReactQueryDevtools({ close }: DevPanelItemProps) {
	const handleClose = () => {
		close();
	};

	return (
		<ReactQueryDevtoolsPanel
			client={queryClient}
			onClose={handleClose}
			style={{
				maxWidth: '100vw',
				width: '100vw',
			}}
		/>
	);
}
